
export const ROUTES = {
    login: "/login",
    feed: "/",
    poll: "/:userSlug/:pollSlug",
    create: "/crear",
    profile: "/:slug",
    myPolls: "/mis-encuestas",
    privacy: "/privacidad",
    terms: "/terminos",
    notFound: "*",
    createForm: "/crear-formulario",
    // Route path templates (used in <Route path={...}>)
    formDetail: "/:userSlug/f/:formSlug",
    formResponses: "/:userSlug/f/:formSlug/respuestas",
    formAnalytics: "/:userSlug/f/:formSlug/analiticas",
    formShare: "/:userSlug/f/:formSlug/compartir",
    responseDetail: "/:userSlug/f/:formSlug/respuestas/:responseId",
} as const;

// Navigation helpers — build concrete URLs from slugs
export const buildFormUrl = (userSlug: string, formSlug: string) =>
    `/${userSlug}/f/${formSlug}`;
export const buildFormResponsesUrl = (userSlug: string, formSlug: string) =>
    `/${userSlug}/f/${formSlug}/respuestas`;
export const buildFormAnalyticsUrl = (userSlug: string, formSlug: string) =>
    `/${userSlug}/f/${formSlug}/analiticas`;
export const buildFormShareUrl = (userSlug: string, formSlug: string) =>
    `/${userSlug}/f/${formSlug}/compartir`;
export const buildResponseDetailUrl = (userSlug: string, formSlug: string, responseId: number | string) =>
    `/${userSlug}/f/${formSlug}/respuestas/${responseId}`;

export const API_ROUTES = {
    // Auth
    googleLogin: "/api/auth/google/",
    logout: "/api/auth/logout/",
    refresh: "/api/auth/token/refresh/",
    user: "/api/auth/user/",

    // Polls
    polls: "/api/polls/",
    pollDetail: (slug: string) => `/api/polls/${slug}/`,
    pollVote: (slug: string) => `/api/polls/${slug}/vote/`,
    pollComments: (slug: string) => `/api/polls/${slug}/comments/`,

    // Comments
    commentDetail: (id: number | string) => `/api/comments/${id}/`,

    // Users
    searchUsers: "/api/users/search/",

    // Forms
    forms: "/api/forms/",
    formDetail: (slug: string) => `/api/forms/${slug}/`,
    formRespond: (slug: string) => `/api/forms/${slug}/respond/`,
    formResponses: (slug: string) => `/api/forms/${slug}/responses/`,
    formExport: (slug: string) => `/api/forms/${slug}/export/`,
    formAnalytics: (slug: string) => `/api/forms/${slug}/analytics/`,
    formDuplicate: (slug: string) => `/api/forms/${slug}/duplicate/`,
    formQR: (slug: string) => `/api/forms/${slug}/qr/`,
    formPrefill: (slug: string) => `/api/forms/${slug}/prefill/`,
    formUploadFile: (slug: string) => `/api/forms/${slug}/upload-file/`,
    formResponseDetail: (slug: string, id: number | string) => `/api/forms/${slug}/responses/${id}/`,
    formResponseEdit: (slug: string, id: number | string) => `/api/forms/${slug}/responses/${id}/edit/`,
} as const;

// Only these paths dont require to send a token
// See /lib/axios.ts
export const NO_AUTH_REQUIRED_API_ROUTES = [
    API_ROUTES.googleLogin,
    API_ROUTES.refresh,
];
